module.exports = {"id":"s3-q2","text":"How do you access your social media?","multiselect":true,"next":"s3-q3","options":[{"id":"s3-q2-a1","text":"On your phone using an app","capability":1,"access":1},{"id":"s3-q2-a2","text":"On your phone using a web browser","capability":1,"access":2},{"id":"s3-q2-a3","text":"On your tablet or computer using an app","capability":1,"access":3},{"id":"s3-q2-a4","text":"On your tablet or computer using a web browser","capability":2,"access":3},{"id":"s3-q2-a5","text":"On someone else’s device","capability":1,"access":-2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s3-q2.json
// module id = 901
// module chunks = 41